<template>
  <div class="login">
    <div class="login-banner"></div>
    <div class="login-view">
      <form class="login-form">
        <input v-model="email" type="email" placeholder="请输入邮箱">
        <input v-model="password" type="password" placeholder="请输入密码">
        <input type="button" value="登录" @click="login">
      </form>
      <p>还没有账号？<router-link to="/register">去注册</router-link></p>
    </div>
  </div>
</template>

<script>
const mailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  }, 
  computed: {

  },
  methods: {
    login () {
      if(!this.email || !this.password) {
        alert('请填写完整信息！')
      } else if (!mailReg.test(this.email)) {
        alert('邮箱格式不正确！')
      } else {
        alert('该邮箱暂未成功注册！')
      }
    }
  }
}
</script>
<style scoped>
.login {
  width: 1024px;
  margin: 50px auto 0;
  padding: 60px 20px;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, .05);
}
.login-view {
  width: 350px;
  height: 340px;
  background-color: #fff;
  border-radius: 6px;
  padding: 20px 0 0;
  text-align: center;
  font-size: 18px;
  overflow: hidden;
}
.login-view h4 {
  margin-bottom: 20px;
}
.login-view p {
  font-size: 14px;
}
.login-form input {
  display: block;
  width: 300px;
  height: 40px;
  margin: 0 auto;
  background-color: #f2f2f2;
  margin-top: 20px;
  border-radius: 5px;
  padding: 0 14px;
}
.login-form input[type="button"] {
  background-color: #34a2f6;
  color: #fff;
  margin: 68px auto 10px;
  cursor: pointer;
}
.login-view a {
  color: #34a2f6;
}
.login-banner{
  width: 550px;
  height: 380px;
  background-image: url('../assets/banner.png');
  float: left;
  margin-right: 30px;
}
</style>